import { useCallback, useState } from 'react';
import { SxProps, Theme } from '@mui/material';
import Button from './Button';
import { ReceiveDeliveryDialog } from './ReceiveDeliveryDialog/ReceiveDeliveryDialog';
import { useLanguage } from 'context/AppContext';
import { useIsHospitalViewer } from 'hooks/useIsHospitalViewer';

const ReceiveDeliveryButton = ({ sx }: { sx?: SxProps<Theme> }) => {
  const lang = useLanguage()[0].ReceiveDeliveryButton;

  const { isHospitalViewer } = useIsHospitalViewer();

  const [showReceiveDeliveryDialog, setShowReceiveDeliveryDialog] = useState(false);

  const handleClick = useCallback(() => {
    setShowReceiveDeliveryDialog(true);
  }, []);

  return (
    <>
      {!isHospitalViewer && (
        <Button label={lang.receiveDelivery} colors="white on active" onClick={handleClick} sx={sx} />
      )}

      {showReceiveDeliveryDialog && (
        <ReceiveDeliveryDialog
          onClose={() => {
            setShowReceiveDeliveryDialog(false);
          }}
        />
      )}
    </>
  );
};

export default ReceiveDeliveryButton;
